import { render } from "./AuthCallback.vue?vue&type=template&id=2736d4c1&scoped=true"
import script from "./AuthCallback.vue?vue&type=script&lang=js"
export * from "./AuthCallback.vue?vue&type=script&lang=js"

import "./AuthCallback.vue?vue&type=style&index=0&id=2736d4c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2736d4c1"]])

export default __exports__